/**
 * Specs Table - Shared JS
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.specs-table-section').forEach(function (section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var table = section.querySelector('[data-specs-table]');
    var toggle = section.querySelector('[data-specs-toggle]');
    if (!table || !toggle) return;

    var more = toggle.querySelector('[data-label-more]');
    var less = toggle.querySelector('[data-label-less]');

    toggle.addEventListener('click', function () {
      var collapsed = table.getAttribute('data-collapsed') === 'true';
      var next = !collapsed;
      table.setAttribute('data-collapsed', next ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', next ? 'false' : 'true');
      if (more) more.hidden = !next;
      if (less) less.hidden = next;
    });
  });
});
